export default function MEDCMembership() {
    return (
<div>
 <h4>Members</h4>
                  <hr/>
                  <p>
                  <b>Kurt Kelly</b>
                  <br/>
                  Term Expires: September 2026
                  </p>
                  <p>
                  <b>John Dewilde</b>
                  <br/>
                  Term Expires: January 2028
                  </p>
                  <p>
                  <b>Don Diretto</b>
                  <br/>
                  Term Expires: January 2029
                  </p>
                  <p>
                  <b>Skip Woolston</b>
                  <br/>
                  Term Expires: January 2029
                  </p>
                  <p>
                  <b>Elisa Migliacci</b>
                  <br/>
                  Term Expires: January 2030
                  </p>
                  <p>
                  <b>Joe McGowan</b>
                  <br/>
                  Term Expires: January 2030
                  </p>
                  <p>
                  <b>John Chessa</b>
                  <br/>
                  Term Expires: January 2030
                  </p>
</div>
    )
}